module.exports = __webpack_public_path__ + "img/windows.5531fce8.png";